# frozen_string_literal: true

module Engine
  module Game
    module G22Mars
    end
  end
end
